// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cFLL7{position:relative;width:100%;padding-bottom:16px;box-sizing:border-box}._HMtU{position:absolute}._HMtU.dCn5C{animation:QLbB2 320ms cubic-bezier(0.22, 1, 0.36, 1) both}.sARvx{left:24px;right:24px;top:16px;bottom:0}.Mux8f{left:12px;right:12px;top:8px;bottom:8px}.Cn1F7{position:relative;width:100%;box-sizing:border-box;border:1px solid #d4d4e0;border-radius:16px;background:#fff;box-shadow:0px 4px 16px rgba(40,40,99,.08)}.Cn1F7.lP7xI{border-color:transparent;background:linear-gradient(#ffffff, #ffffff) padding-box,linear-gradient(135deg, #2cf1ff 0%, #7856f9 50%, #ff5f8f 100%) border-box}.Cn1F7.NbmfU{height:304px}.Cn1F7.dMojj{height:192px}.ixRkB{padding-bottom:8px}.ixRkB .sARvx{left:12px;right:12px;top:8px}.ixRkB .Mux8f{left:8px;right:8px;top:4px;bottom:4px}.ixRkB .Cn1F7.NbmfU{height:236px}@keyframes QLbB2{from{transform:translateY(3px)}to{transform:none}}@media(prefers-reduced-motion: reduce){._HMtU.dCn5C{animation:none}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"deck": `cFLL7`,
	"backCard": `_HMtU`,
	"settling": `dCn5C`,
	"back-card-settle": `QLbB2`,
	"farBackCard": `sARvx`,
	"nearBackCard": `Mux8f`,
	"front": `Cn1F7`,
	"ai": `lP7xI`,
	"card": `NbmfU`,
	"placeholder": `dMojj`,
	"compact": `ixRkB`
};
export default ___CSS_LOADER_EXPORT___;
